import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from "react-router-dom"
import App from './App'
import { initializeApp } from "firebase/app";


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDC4L1gQWz1fMQj5_S616Z_Ofd05p2q0uk",
  authDomain: "earth-identity-project.firebaseapp.com",
  projectId: "earth-identity-project",
  storageBucket: "earth-identity-project.appspot.com",
  messagingSenderId: "403251360797",
  appId: "1:403251360797:web:c13c9e867d77fddaf782f4"
};

// Initialize Firebase
initializeApp(firebaseConfig);

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)